module.exports = __webpack_public_path__ + "img/test-payment.795dca06.png";